<template>
  <BreadCrumb :model="getItems()" />
</template>

<script setup>
import BreadCrumb from '@nuxt-common/atomic-ui/app/components/breadcrumb/Breadcrumb.vue';
import { UserStatus } from '@vue-util/cookie';

const router = useRouter();

const props = defineProps({
  currentPage: {
    type: String,
    required: true,
  },
});

const pnrLink = () => {
  const from = router?.options?.history?.state?.back;
  // regex checks if prev route was pnr page
  if (/^(\/purchases\/)(online|store)(?!\/)(\?)?.*$/.test(from)) return from;
  // otherwise we redirect leave to default
  return '/purchases';
};

const getItems = () => {
  switch (props.currentPage) {
    case 'P&R':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: '',
        },
      ];
    case 'Tracking':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: pnrLink(),
        },
        {
          label: 'Tracking',
          to: '/',
        },
      ];
    case 'Item':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: pnrLink(),
        },
        {
          label: 'Item Details',
          to: '/',
        },
      ];
    case 'OrderDetails':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: pnrLink(),
        },
        {
          label: 'Order Details',
          to: '/',
        },
      ];
    case 'Purchase Details':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: pnrLink(),
        },
        {
          label: 'Purchase Details',
          to: '/',
        },
      ];
    case 'rdv':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          url: pnrLink(),
        },
        {
          label: 'Return Details',
          to: '',
        },
      ];
    case 'Return Details':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          url: pnrLink(),
        },
        {
          label: 'Return Details',
          to: '',
        },
      ];
    case 'Replacement Details':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          url: pnrLink(),
        },
        {
          label: 'Replacement Details',
          to: '',
        },
      ];
    case 'Exchange Details':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          url: pnrLink(),
        },
        {
          label: 'Exchange Details',
          to: '',
        },
      ];
    case 'ERROR':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          url: pnrLink(),
        },
        {
          label: 'Error',
          to: '',
        },
      ];
    case 'Order Lookup': {
      const breadcrumbItems = [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: pnrLink(),
        },
        {
          label: 'Order and Furniture Lookup',
          to: '',
        },
      ];
      if (!UserStatus.isSignedIn()) {
        breadcrumbItems.splice(1, 1);
      }
      return breadcrumbItems;
    }
    case 'International Lookup':
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: pnrLink(),
        },
        {
          label: 'International Order Tracking',
          to: '',
        },
      ];
    default:
      return [
        {
          label: 'My Account',
          url: '/myaccount/home',
        },
        {
          label: 'Purchases & Returns',
          to: '/',
        },
      ];
  }
};
</script>
